import React, { Fragment, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import useStorage from "../../Hooks/useStorage";
import PdfsHelper from '../../Helpers/Pdf';

import	"../Estudiantes/PDF/PDF.css";
import Loader from '../../Components/Loader';


const AgregarPdf = () => {
    const { tipo } = useParams();
    const vista = [
        "HORARIOS",
        "HORARIO DE EXÁMENES",
        "CALIFICACIONES",
        "DERECHO A EXAMEN"
    ];
    const folder = [
        "horario",
        "horario_examen",
        "calificaciones",
        "derecho_examen"
    ];

    const [flag, setFlag] = useState(true);
    const [state, setState] = useState({
        campo: tipo
    });
    const [file, setFile] = useState(false);

    const [consulta, setConsulta] = useState("");
    let [response] = useStorage(consulta);

    useEffect(() => {
        if (response.url) subirDB(response.url)
    }, [response]);

    const leerArchivo = e => {
        setFile(e.target.files[0])
    }

    const leerDato = e => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        })
    }

    const subirPdf = e => {
        e.preventDefault();

        if (!file || !state.tipo) return Swal.fire("Error!", "Faltan datos por llenar", "error");
        
        setFlag(false);
        setConsulta({consulta:"agregarPdf", name:state.titulo, folder:`pdfs/${folder[tipo]}/`, file});
    }

    const subirDB = async archivo => {
        let nuevo = {...state, archivo}

        let res = await PdfsHelper.agregarPdf(nuevo);
        setFlag(true);
        
        if (res.success) {
            window.location.replace(`/estudiantes-pdf/${tipo}`)
        } else {
            Swal.fire("Error!", "No se pudo agregar el archivo", "error")
        }
    }

    return(
        <Fragment>
            {!flag && (
                <div style={{width:"100%", height:"100vh", position:"fixed", top:"0", background:"#00000059", zIndex:"9999"}}>
                    <Loader />
                </div>
            )}
            <div>
                <p className='titulo_solicitud' style={{textAlign:"center"}}>
                    Agregar PDF {vista[tipo]}
                </p>
                <div className='cont_horario'>
                    <form onSubmit={subirPdf}>
                        <div class="file-field input-field">
                        <div class="btn">
                            <span>File</span>
                            <input onChange={leerArchivo} type="file" />
                        </div>
                        <div class="file-path-wrapper">
                            <input onChange={leerArchivo} class="file-path validate" type="text" placeholder="Upload one or more files" />
                        </div>
                        </div>

                        <div className='flex_padre_2'>
                            
                            <div className='flex_pdf'>
                                <p className='texto_pdf'>
                                    Nombre del archivo
                                </p>
                                <div class="input-field col s6">
                                    <input onChange={leerDato} id="titulo" name='titulo' type="text" class="validate" style={{width:"100%"}} required/>
                                </div>
                            </div>

                            <div className='flex_pdf' style={{display:"flex", justifyContent:"center", flexDirection:"column"}}>
                                <p className='texto_pdf'>
                                    Calificación
                                </p>
                                <div>
                                    <p>
                                        <label>
                                            <input value={1} onChange={leerDato} id="indeterminate-checkbox" type="radio" name='tipo' />
                                            <span className='texto_pdf_2'>Licenciaturas</span>
                                        </label>
                                    </p>
                                    <p>
                                        <label>
                                            <input value={2} onChange={leerDato} id="indeterminate-checkbox" type="radio" name='tipo' />
                                            <span className='texto_pdf_2'>Cuatrimestre</span>
                                        </label>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={{display:"flex", justifyContent:"center"}}>
                            <button type='submit' className='btn_h1'>
                                Agregar archivo
                            </button>
                            <Link to={`/estudiantes-pdf/${tipo}`} className='btn_h2'>
                                Regresar
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default AgregarPdf;